import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getFormEvalFactor,
  deleteFormEvalFactor,
  editFormEvalFactor,
  saveFormEvalFactor,
  getFormEvalCompeteciaById,
} from "../../redux/evaluacion_desempenio/formularioEval_Factor/actions";

import toastr from "toastr";
import * as Yup from "yup";

const TableFormEvalQuestionsFactorComponent = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [data, setData] = useState([]);
  const [value, setValue] = useState(props.metrica_id ? props.metrica_id : "");
  const [error, setError] = useState("");
  const [showFormModal, setShowFormModal] = useState(false);
  const [formError, setFormError] = useState("");
  const [timer, setTimer] = useState(null);
  const dispatch = useDispatch();
  const filters = [{ id: "nombre", desc: "Competencia" }];
  const [arrayGrados, setArrayGrados] = useState([]);
  const {
    loaderEvalFormFactor,
    evalFormFactor,
    evalFormFactorFalla,
    saveLoaderEvalFormFactor,
    evalFormFactorFormError,
  } = useSelector((store) => store.evalFormFactor);
  // console.log(evalFormFactor);
  const handleCheckbox = ({ target: { checked, value: checkValue } }) => {
    //debugger
    if (checked) {
      // setValue(checkValue)
      const temp = props.arrayGrados;
      temp[props.indexFactor][props.index].grado = parseInt(checkValue);
      setArrayGrados(temp);
    }
  };

  return (
    <>
      {props.metrica && (
        <>
          {props.metrica.map((item) => (
            <>
            {props.metrica_id || !props.isEdit ? (
               <td>
               {props.item && (
                 <>
                   {["radio"].map((type) => (
                     <div
                       key={`inline-${type}`}
                       className="mb-3 d-flex flex-wrap justify-content-center align-items-center"
                     >
                       <Form.Check
                         inline
                         checked={value === item.id}
                         onChange={(e) => {
                           setValue(item.id);
                           handleCheckbox(e);
                           //const temp = props.arrayGrados;
                           //temp[props.indexFactor][props.index].metrica_id = parseInt(e.currentTarget.value);
                           // setArrayGrados(temp);
                         }}
                         //defaultChecked={props.metrica_id && props.metrica_id=== item.id}
                         // onChange={(e) => {
                         //   const temp = props.arrayGrados;
                         //  temp[props.indexFactor][props.index].metrica_id = parseInt(e.currentTarget.value);
                         //setArrayGrados(temp);
                         //}}
                         value={item.id}
                         label=""
                         name={`group ${props.indexFactor}${props.index}`}
                         type="radio"
                         id={`inline-${type}-1`}
                         disabled={
                           (props.type && parseInt(props.type) === 2) ||
                           props.isDisabled
                         }
                       />
                     </div>
                   ))}
                 </>
               )}
             </td>
            ) : (
              <td bgcolor="#96C0DF">
              {props.item && (
                <>
                  {["radio"].map((type) => (
                    <div
                      key={`inline-${type}`}
                      className="mb-3 d-flex flex-wrap justify-content-center align-items-center"
                    >
                      <Form.Check
                        inline
                        checked={value === item.id}
                        onChange={(e) => {
                          setValue(item.id);
                          handleCheckbox(e);
                          //const temp = props.arrayGrados;
                          //temp[props.indexFactor][props.index].metrica_id = parseInt(e.currentTarget.value);
                          // setArrayGrados(temp);
                        }}
                        //defaultChecked={props.metrica_id && props.metrica_id=== item.id}
                        // onChange={(e) => {
                        //   const temp = props.arrayGrados;
                        //  temp[props.indexFactor][props.index].metrica_id = parseInt(e.currentTarget.value);
                        //setArrayGrados(temp);
                        //}}
                        value={item.id}
                        label=""
                        name={`group ${props.indexFactor}${props.index}`}
                        type="radio"
                        id={`inline-${type}-1`}
                        disabled={
                          (props.type && parseInt(props.type) === 2) ||
                          props.isDisabled
                        }
                      />
                    </div>
                  ))}
                </>
              )}
            </td>
            )}
             
            </>
          ))}
        </>
      )}
    </>
  );
};
export default TableFormEvalQuestionsFactorComponent;
